import React, { useEffect, useState ,useRef} from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend,CategoryScale } from "chart.js/auto";
import { getDashBoardDetails } from "../../services/apiServices/GetServices";
import { Bar ,Line} from "react-chartjs-2";

//component imports
import DonutChart from "../../utils/resuableComponents/DonutGraph";
import BarGraph from "../../utils/resuableComponents/BarGraph";
import StackedGraph from "../../utils/resuableComponents/StackedGraph";
import Loader from "../loadingScreens/Loader";
ChartJS.register(ArcElement, Tooltip, Legend);

const AdminDashboard = () => {

   const [dashBoardValues,setDashBoardValues]=useState()
   const [storesAndServices,setStoresAndServices]=useState([])
   const [storesData,setStoresData]=useState([])
   const [usersRegistered,setUserRegistered]=useState([])
   const [amountinvested,setAmountInvested]=useState([])
   const [amountInvestedData,setAmountInvestedData]=useState()
   const [investedMonths,setInvestedMonths]=useState()
   const [reversedMonths,setReversedMonths]=useState()
   const [reversedData,setReversedData]=useState()
   const [serviceColors,setServiceColors]=useState()
   const [addedColorServices,setAddedColorServices]=useState([])
   const [isLoader,setIsLoader]=useState(false)
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [errorMessage,setErrorMessage]=useState("")
  
   useEffect(() => {
    callDashBoardDetailsApi()
}, [])


useEffect(() => {
    let arrayData = []
    let monthsArray = []

    amountinvested.map((data)=> {
        let amount = data?.invested_amount
        let months = data?.month 
        arrayData.push(parseInt(amount))
        monthsArray.push(months)
    })
    setAmountInvestedData(arrayData)
    setInvestedMonths(monthsArray)

}, [amountinvested])

useEffect(() => {
    if(investedMonths !== undefined){
   let reverseMonths = investedMonths.reverse()
    let reveredData = amountInvestedData.reverse()
       setReversedMonths(reverseMonths)
       setReversedData(reveredData)
    }
 }, [investedMonths])

 useEffect(() => {
  if(serviceColors !== undefined){
    serviceColors.map((data) => {
     let newObject = data;
      let newArray =storesAndServices.map(item => item.service_name === newObject.service_name ? Object.assign(item, newObject) : item)
      setAddedColorServices(newArray)
    });
  }

}, [serviceColors])


const formatNumber = (value) =>  {
  const numStr = String(value);

   // Check the length of the numStr
   const numLength = numStr.length;

  const firstTwoDigits = numStr.substring(0, numLength - 7);

  if (value >= 10000000) {
    return (value / 10000000).toFixed(2) + 'Cr';
  } else if (value >= 100000) {
    return (value / 100000).toFixed(2) + 'L';
  } else {
    return value;
  }
}

const buttonStyle = {
  backgroundColor: "#0A2FB6", // Set your desired background color
  color: 'white', // Set the text color if needed
};

   const data = {
    labels: reversedMonths,
    datasets: [
      {
        label: "Amount Invested",
        data: reversedData,
        fill: true,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,0.2)",
        tension:0.5
      }
    ]
  };

  const options = {
    plugins: {
      legend: {
        display: false, // Hide dataset labels
      },
    },
    scales: {
        x: {
          grid: {
            display: false, // Hide y-axis grid lines
          },
          ticks: {
            color: 'black' // Change the color of x-axis labels here
          }
        },
        y: {
          beginAtZero: true,
          ticks: {
            color: 'black' // Change the color of x-axis labels here
          }
        },
      }, 
    maintainAspectRatio: false, // Make the chart responsive
  responsive: true, // Enable responsiveness
  };
  
const callDashBoardDetailsApi = async () => {
  setIsLoader(true)
  try{
    const res = await getDashBoardDetails("dashboard")
    if (res?.success) {
       setDashBoardValues(res?.dashboard[0])
       setStoresAndServices(res?.stores_services)
       setStoresData(res?.stores)
       setAmountInvested(res?.shares)
       setUserRegistered(res?.user)
       setServiceColors(res?.colors)
    }else{
        console.log("res",res?.message)
    }
  }catch(error){
    console.log("error",error)
  }   
}

    return (
        <div class="col-lg-12 " >
          {isLoader ? <Loader/> : null }
            <div class="d-flex flex-row justify-content-between align-items-center w-100 border-bottom p-2">
            <h1 class="fs-4 mx-3 Montserrat fw-semi-bold">
            Dashboard
            </h1>
        </div>
        <div class="container  mt-2 mb-2"> 
          
        <div className="d-flex justify-content-between  col-md-11 my-1">
            {/* <div class="d-flex col-md-10 mx-2 "> */}
        <div class="col-md-4 p-2 mx-3  d-flex flex-column justify-content-center align-items-center text-center boxBackgroundStyle ">
                    <h4  class="colorPrimary fw-bold">Total Users</h4>
                    <h2 class="colorPrimary  fw-bold">{dashBoardValues?.Total_Users}</h2>
                 </div>
                <div class="col-md-4 p-2  mx-3 d-flex flex-column justify-content-center text-center align-items-center boxBackgroundStyle ">
                    <h4  class="colorPrimary fw-bold">Total Stores</h4>
                    <h2 class="colorPrimary  fw-bold">{dashBoardValues?.Total_Stores}</h2>
                 </div>
                <div class="col-md-4 p-2  mx-3 d-flex flex-column justify-content-center text-center align-items-center boxBackgroundStyle ">
                    <h4  class="colorPrimary fw-bold">Pending Requests</h4>
                    <h2 class="colorPrimary  fw-bold">{dashBoardValues?.total_pending_req}</h2>
                 </div>
            </div>  
            <div className="d-flex justify-content-between  col-md-11 my-2">
          
                 <div class="col-md-4 p-2  mx-3 d-flex flex-column justify-content-center align-items-center text-center  boxBackgroundStyle ">
                    <h4  class="colorPrimary fw-bold">Amount Invested</h4>
                    <span data-bs-toggle="tooltip" data-bs-placement="top" title={`₹${dashBoardValues?.total_amount_invested === null ? 0 : dashBoardValues?.total_amount_invested}`} class="ms-3" >
                    <h2 class="colorPrimary  fw-bold">₹{dashBoardValues?.total_amount_invested === null ? 0 : formatNumber(dashBoardValues?.total_amount_invested)}</h2>
                    </span>
                 </div>
                 <div class="col-md-4 p-2  mx-3 d-flex flex-column justify-content-center align-items-center text-center  boxBackgroundStyle ">
                    <h4  class="colorPrimary fw-bold">Total Shares Sold</h4>
                    <span data-bs-toggle="tooltip" data-bs-placement="top" title={`${dashBoardValues?.total_shares_sold === null ? 0 : dashBoardValues?.total_shares_sold}`} class="ms-3" >
                    <h2 class="colorPrimary  fw-bold">{dashBoardValues?.total_shares_sold === null ? 0 : formatNumber(dashBoardValues?.total_shares_sold) }</h2>
                    </span>
                 </div>
                 <div class="col-md-4 p-2  mx-3 d-flex flex-column justify-content-center align-items-center text-center  boxBackgroundStyle ">
                    <h4  class="colorPrimary fw-bold">Shares Type Count</h4>
                    <span data-bs-toggle="tooltip" data-bs-placement="top" title={`${dashBoardValues?.share_type_count === null ? 0 : dashBoardValues?.share_type_count}`} class="ms-3" >
                    <h2 class="colorPrimary  fw-bold">{dashBoardValues?.share_type_count === null ? 0 :formatNumber(dashBoardValues?.share_type_count)}</h2>
                      </span>
                 </div>
            </div> 
             <div class="col-md-12 d-flex justify-content-center mt-3">
                <div class="d-flex flex-column justify-content-start align-items-start mx-3 me-xxl-4 h-50 col-md-7  graphBackGround">
                    <h5 class="mainHeading m-2">Amount Invested</h5>
                    <div class="w-100 mt-4 pt-2">
                    <Line data={data} style={{height:"500px",width:"100%"}} options={options} />
                    </div>
                </div>
                {
                  storesAndServices !== undefined ? 
                  <div class="d-flex flex-column justify-content-center align-items-center  
                  h-50 me-3 me-xxl-4 col-md-4 graphBackGround">
                    
                     <h5 class="mainHeading align-self-start m-2">Stores</h5>
                    { 
                     storesAndServices !== null 
                     ? 
                     storesAndServices[0]?.store_percentage !== null && storesAndServices[0]?.store_percentage !== null && storesAndServices[0]?.store_percentage !== null && storesAndServices[0]?.store_percentage !== null ?
                     <DonutChart data={storesAndServices} serviceColors={serviceColors}  /> :
                     <div style={{height:"370px",width:"100%",justifyContent:"center",display:"flex",alignItems:"center"}}>
                     <h4  >No Stores</h4> 
                       </div> 
                       :
                     <div style={{height:"370px",width:"100%",justifyContent:"center",display:"flex",alignItems:"center"}}>
                     <h4  >No Stores</h4> 
                       </div> 
                    } 
                 
                 {
                     addedColorServices.map((data,index) => {
                         return (
                             <div class="d-flex w-100 justify-content-center align-items-center" key={index}> 
                                 <div>
                                 <p style={{backgroundColor:`${data?.color}`,width:"7px",height:"7px",borderRadius:"25px",margin:"0px",marginBottom:"8px",marginRight:"5px"}}>{""}</p>
                                 </div>
                                 <h5 class="montserrat w-50">{data?.service_name}</h5>
                                 <h5  class="montserrat w-25" > {data?.store_percentage === null ? 0 : data?.store_percentage} %</h5>
                                 </div>
                             
                         )
                     })
                 }
                 </div>    
                 :
                 null
                }
               
            </div> 
            <div class="col-md-12 d-flex justify-content-center   mt-3">
            <div class="d-flex flex-column  h-25 mx-3 me-xxl-4  col-md-6 graphBackGround">
            <h5 class="mainHeading align-self-center m-2">Users Registering Per Month</h5>
            <div class="w-100 mt-4 pt-2">
            <BarGraph data={usersRegistered} />   
            </div>
                  
            </div>
            <div class="d-flex flex-column h-25   col-md-5 me-3 me-xxl-4 graphBackGround">
                <h5  class="mainHeading align-self-center  m-2">Stores Opening Per Month</h5>
                <StackedGraph data={storesData}  serviceColors={serviceColors} />
                <div class="d-flex flex-row w-100 justify-content-center mt-1 flex-wrap mx-4 align-items-center "> 
                {
                    storesAndServices.map((data,index) => {
                        return (
                                 <div class="d-flex justify-content-start align-items-center w-50" key={index}>
                                   <div>
                                <p style={{backgroundColor:`${data?.color}`,width:"7px",height:"7px",borderRadius:"25px",margin:"0px",marginBottom:"8px",marginRight:"5px"}}>{""}</p>
                                </div>
                                <h5 class="montserrat ">{data?.service_name}</h5>
                                </div>
                        )
                    })
                }
                 </div>
                
            </div>
            </div>
            </div>

        </div>
    )
}

export default AdminDashboard